<template>
  <div class="tour-complaint">

    <div class="tour-complaint__item"
         @click="openComplaintPopup">
      <icon class="tour-complaint__item-icon"
            icon="flag-gray"/>
      <span>{{ $t("serpDetail.complaint.title")}}</span>
    </div>
    <popup v-model="popupIsOpen"
           size="sm"
           @close="closeComplaintPopup"
    >
      <div class="complaint-popup">
        <div  class="complaint-popup__preloader-container" v-if="preloader">
          <div class="complaint-popup__preloader">
            <preloader visible position="static" />
          </div>
        </div>

        <div class="complaint-popup__step-1" v-if="step==1">
          <div class="complaint-popup__header" v-html="$t('serpDetail.complaint.complaintPopup.step_1.header')"/>
         <div class="complaint-popup__body">
            <div class="complaint-popup__body-header _header_1" v-html="$t('serpDetail.complaint.complaintPopup.step_1.bodyHeader')"/>
           <div  class="complaint-popup__body-content">
              <radio-buttons v-model="complaint.radioValue" value="1">
                <div class="radio_buttons-label">
                  {{$t('serpDetail.complaint.complaintPopup.step_1.radio_1')}}
                </div>
              </radio-buttons>
             <radio-buttons v-model="complaint.radioValue" value="2">
               <div class="radio_buttons-label">
                 {{$t('serpDetail.complaint.complaintPopup.step_1.radio_2')}}
               </div>
             </radio-buttons>
             <radio-buttons v-model="complaint.radioValue" value="3">
               <div class="radio_buttons-label">
                 {{ $t('serpDetail.complaint.complaintPopup.step_1.radio_3') }}
               </div>
             </radio-buttons>
           </div>
           <yt-button
             class="complaint-popup__btn"
             :disabled="!step1ValueSelected"
             color="green"
             @click="nextStep"
           >
             {{$t('serpDetail.complaint.complaintPopup.next')}}
           </yt-button>
         </div>
        </div>
        <div  class="complaint-popup__step-2" v-if="step==2">
          <div class="complaint-popup__header" v-html="$t(`serpDetail.complaint.complaintPopup.step_1.radio_${complaint.radioValue}`)"/>
          <div class="complaint-popup__body" >
            <div class="complaint-popup__body-header _header_2"
                 :class="{'_left': complaint.radioValue < 3}"
                 v-html="$t(`serpDetail.complaint.complaintPopup.step_2.bodyHeader_${complaint.radioValue}`)"
            />
            <div class="complaint-popup__body-content" v-if="complaint.radioValue==1">
              <yt-input
                @input="changeField($event, 'link')"
                class="complaint-popup__input"
                :placeholder="$t(`serpDetail.complaint.complaintPopup.step_2.placeholder_1`)"
                type="text"
                v-model="complaint.link"
                :value="complaint.link"
                :hint="$t(`serpDetail.complaint.complaintPopup.step_2.hint_1`)"
                :solo="true"
                :error="$v.complaint.link.$error"
              />
            </div>
            <div  class="complaint-popup__body-content _content_step_2" v-else>
              <yt-input
                class="complaint-popup__input"
                @input="changeField($event, 'textAreaValue')"
                :label="$t(`serpDetail.complaint.complaintPopup.step_2.placeholder_2`)"
                type="textarea"
                maxlength="500"
                v-model="complaint.textAreaValue"
                :value="complaint.textAreaValue"
                :hint="$t(`serpDetail.complaint.complaintPopup.step_2.hint_2`)"
                :error="$v.complaint.textAreaValue.$error"
              />
              <yt-upload-file-zone
                class="complaint-popup__file-zone"
                :text="$t(`serpDetail.complaint.complaintPopup.uploadFile`)"
                :files="complaint.uploadedPhotos"
                :load-amount="loadedPhotosAmount"
                max-items-amount="3"
                @delete-file="deleteFile"
                @drop-files="uploadFiles"/>
              <div class="complaint-popup__error" v-if="uploadPhotoError">
                {{uploadPhotoError}}
              </div>
              <div class="complaint-popup__note"
                   v-if="complaint.radioValue == 3"
                   v-html="$t(`serpDetail.complaint.complaintPopup.step_2.hint_3`)">
              </div>
            </div>
            <div @mouseover="validateForm">
              <yt-button
                class="complaint-popup__btn"
                :disabled="btnDisabled"
                color="green"
                @click="nextStep(true)"
                @mouseover="validateForm(!(complaint.textAreaValue.length || complaint.link.length))"
              >
                {{$t('serpDetail.complaint.complaintPopup.step_2.btnText')}}
              </yt-button>
            </div>
          </div>

        </div>
        <div  class="complaint-popup__step-3" v-if="step==3">
          <div class="complaint-popup__done-icon">
            <Icon icon="checkmark-thick"/>
          </div>
          <div class="complaint-popup__header _header_3" v-html="$t(`serpDetail.complaint.complaintPopup.step_3.bodyHeader`)"/>
          <yt-button
            class="complaint-popup__btn"
            :disabled="!(complaint.textAreaValue.length || complaint.link.length)"
            color="gray"
            @click="closeComplaintPopup"
          >
            {{$t('serpDetail.complaint.complaintPopup.step_3.btnText')}}
          </yt-button>
        </div>
      </div>
    </popup>
  </div>

</template>
<script>
import Popup from "@/components/ui-kit/yt-popup";
import RadioButtons from "@/components/ui-kit/yt-radio";
import YtButton from "@/components/ui-kit/yt-button";
import YtInput from "@/components/ui-kit/yt-input";
import YtUploadFileZone from "@/components/ui-kit/yt-upload-file-zone";
import Preloader from "@/components/ui-kit/preloader/index.vue";
import Icon from "@/components/icons/index.vue";
import {mapGetters} from "vuex";
import { requiredIf} from "vuelidate/lib/validators";
import { axiosComplaint } from "@/services/scopes/axios-complaint";

export default {
  components: {
    Popup,
    RadioButtons,
    YtButton,
    YtInput,
    YtUploadFileZone,
    Icon,
    Preloader
  },
  props: {
    tourId: {
      type: Number,
      required: true,
    }
  },
  data() {
    return {
      needOpen: false,
      popupIsOpen: false,
      preloader: false,
      step: 1,
      loadedPhotosAmount: 0,
      uploadPhotoError: null,
      complaintTypes: {
        1:'duplicate',
        2: 'Copyright infringement',
        3: 'Incorrect information',
      },
      complaint: {
        link: "",
        textAreaValue: "",
        uploadedPhotos: [],
        radioValue: 0,
      }
    }
  },
  validations: {
    complaint: {
      link: {
       required: requiredIf(({ radioValue }) => radioValue == 1),
        url: (value, { radioValue }) => {
         if(radioValue == 1) {
           // eslint-disable-next-line
           const regUrl = /^(http|https):\/\/youtravel\.me\/tours\/\d*\/?[^(:\/\/)]*$/gmi;

           return regUrl.test(value);
         }
         return true;
        }
      },
      textAreaValue: {
        required: requiredIf(({ radioValue }) => radioValue > 1),
        minLength:  (value, {radioValue}) => {
          if(radioValue >1) {
            return value.length >= 20
          }
          return true;},
        maxLength: (value, {radioValue}) => {
          if(radioValue >1) {
            return value.length <= 500
          }
          return true;},
      },
    }
  },
  computed: {
    ...mapGetters("user", ["getUserLoginStatus"]),
    step1ValueSelected() {
      return this.complaint.radioValue !== 0;
    },
    btnDisabled() {
      if(
        !((this.complaint.textAreaValue.length &&  !this.$v.complaint.textAreaValue.$invalid)|| (this.complaint.link.length && !this.$v.complaint.link.$invalid))
        || this.preloader) {
        return true;
      }
      return false;
    }
  },
  watch: {
    getUserLoginStatus(val) {
      if (val && this.needOpen) {
        this.popupIsOpen = true;
      }
    },
  },
  methods: {
    openComplaintPopup() {
      if(!this.getUserLoginStatus){
        this.needOpen = true;
        fakeWindow.showVueAuthModal()
      }
      else {
        this.popupIsOpen = true;
      }
    },
    closeComplaintPopup() {
      this.needOpen = false;
      this.preloader = false;
      this.popupIsOpen = false;
      this.step = 1;
      this.complaint.radioValue = 0;
      this.complaint.link = "";
      this.complaint.textAreaValue = "";
      this.complaint.uploadedPhotos = [];
      this.$v.$reset();
    },
    nextStep(needValidate = false) {
      if(this.step == 2 && needValidate) {
        this.$v.complaint.$touch();

        if (!this.$v.complaint.$invalid) {
          this.preloader = true;
          const data = {
            type: this.complaintTypes[this.complaint.radioValue],
            photos: this.complaint.uploadedPhotos.map((item) => item.id),
            message: this.complaint.radioValue == 1 ? this.complaint.link : this.complaint.textAreaValue,
          }

          axiosComplaint.addComplaint(this.tourId, data)
            .then(({ data }) => {
              if(data.success) {
                this.preloader = false;
                this.step++;
              }
            })
            .catch((error) => {
              console.error(error);
            });
         //
        }
      }
      else {
        this.step++;
      }

    },
    deleteFile(evt) {
      const index = this.complaint.uploadedPhotos.findIndex((photo) => photo.id === evt);
      this.complaint.uploadedPhotos.splice(index, 1);

    },
    async uploadFiles(evt) {
      this.uploadPhotoError = null;
      this.loadedPhotosAmount = evt.amount;
      try {
        if(evt.amount) {
          const {data: {success, data}} = await axiosComplaint.uploadPhoto(evt.formData)
          if (!success) {
            return;
          }
          for(let key in data) {
            this.complaint.uploadedPhotos.push({
              id:   data[key].files.fileId,
              path:  data[key].files.path,
            })
            this.loadedPhotosAmount--;
          }
        }
      }
      catch (e) {
        this.uploadPhotoError = e?.response?.data?.data?.message;
        this.loadedPhotosAmount = 0;
        console.error(e);
      }

    },
    changeField(evt, field) {
      this.complaint[field] = evt;
    },
    validateForm(needValidate = false) {
      if(needValidate) {
        this.$v.complaint.$touch();
      }
    }
  }
}
</script>
<style lang="scss">
.tour-complaint{
  display: flex;
  align-items: center;
  justify-content: center;



  &__item {
    cursor: pointer;
    color: var(--text-grey, var.$secondary);
    font-family: var.$font-family-sf-pro-text;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 16px; /* 114.286% */
    letter-spacing: -0.28px;
    text-decoration-line: underline;
    display: flex;

    &-icon {
      margin-right: 8px;
    }
  }
}
.complaint-popup{
 /* width: 420px;*/
  &__preloader {
    width: 100%;
    &-container {
      position: absolute;
      height: 100%;
      width: 100%;
      top: 0;
      left: 0;
      display: flex;
      z-index: 2;
      align-items: center;
      justify-content: center;
    }
  }
  &__header{
    color: var(--black, #222);
    text-align: center;

    /* h4 */
    font-family: var.$font-family-sf-pro-text;
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: 22px; /* 122.222% */
    letter-spacing: -0.36px;
  }
  &__body {
    display: flex;

    flex-direction: column;
    gap: 24px;
    &-header{
      color: var(--black, #222);
      text-align: center;
      font-family: var.$font-family-sf-pro-text;
      font-size: 14px;
      font-style: normal;
      font-weight: 600;
      line-height: 22px;
      letter-spacing: -0.14px;
    }
    &-content{
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 10px;
      align-self: stretch;
    }
  }
  &__input {
    width: 100%!important;
  }
  &__btn{
    width: 100%
  }
  &__file-zone {
    margin-left: -19px!important;
    margin-bottom: 0!important;
    div.yt-upload-file-item {
      margin-left: 19px!important;
      width: 96px;
      height: 96px;
    }
    div.yt-drop-zone__empty {
      margin: 0!important;
    }

    @media (min-width: var.$sm) {
      margin-left: -28px!important;
      div.yt-upload-file-item {
        margin-left: 28px!important;
        width: 112px;
        height: 112px;
      }
    }
  }
  &__done-icon {
    width: 64px;
    height: 64px;
    border-radius: 100px;
    background: linear-gradient(154deg, #F9FBEC 4.03%, #F1F8F3 83.99%);
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 16px;
     svg {
       height: 40px;
       width: 40px;
        path {
          stroke-width: 1px;
        }
     }
  }
  &__step-3 {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }
  &__note{
    color: var(--text-grey, var.$secondary);
    text-align: center;
    font-family: var.$font-family-sf-pro-text;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px; /* 133.333% */
    letter-spacing: -0.24px;
    a {
      color: var(--text-grey, var.$secondary);
      font-family: var.$font-family-sf-pro-text;
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: 16px;
      letter-spacing: -0.24px;
      text-decoration-line: underline;
    }
  }
  &__error {
    color: var.$ruby-400;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px; /* 133.333% */
    letter-spacing: -0.24px;
  }
}
._left {
  text-align: left;
}
._header_1 {
  padding-top: 24px;
}
._header_2 {
  padding-top: 27px;
}
._header_3 {
  margin-bottom: 32px;
  line-height: 26px;
}
._content_step_2 {
  gap: 24px;
}

</style>
